export const formatDate = (dateString) => {
  const options = { day: "2-digit", month: "long", year: "numeric" };
  return new Intl.DateTimeFormat("id-ID", options).format(new Date(dateString));
};

export const formatDateTime = (dateString) => {
  const options = { 
    day: "2-digit", 
    month: "long", 
    year: "numeric", 
    hour: "2-digit", 
    minute: "2-digit", 
    second: "2-digit",
    hour12: false
  };
  return new Intl.DateTimeFormat("id-ID", options).format(new Date(dateString));
};

const formatDateTimeWithZone = (dateString, timeZone = "Asia/Jakarta") => {
  const options = { 
    day: "2-digit", 
    month: "long", 
    year: "numeric", 
    hour: "2-digit", 
    minute: "2-digit", 
    second: "2-digit",
    hour12: false, // Format 24 jam
    timeZone // Set zona waktu
  };
  return new Intl.DateTimeFormat("id-ID", options).format(new Date(dateString));
};

// Export fungsi
export const formatDateTimeWIB = (dateString) => formatDateTimeWithZone(dateString, "Asia/Jakarta"); // WIB
export const formatDateTimeWITA = (dateString) => formatDateTimeWithZone(dateString, "Asia/Makassar"); // WITA
export const formatDateTimeWIT = (dateString) => formatDateTimeWithZone(dateString, "Asia/Jayapura"); // WIT
